import { render } from "./RegisterPopup.vue?vue&type=template&id=eb42f29e&scoped=true&ts=true"
import script from "./RegisterPopup.vue?vue&type=script&lang=ts"
export * from "./RegisterPopup.vue?vue&type=script&lang=ts"

import "./RegisterPopup.vue?vue&type=style&index=0&id=eb42f29e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb42f29e"]])

export default __exports__